// Ported from Studio Playground frontend/src/components/booth/PizzulMoves.jsx.
export const copyText = async (value) => {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch (_error) {
    const area = document.createElement('textarea');
    area.value = value;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const copied = document.execCommand('copy');
    area.remove();
    return copied;
  }
};
